export const aciDefaultUser = {
    iconName: 'default-user',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M7.334 9.999a4.666 4.666 0 109.333 0 4.666 4.666 0 00-9.333 0zM18.145 19.889a8.661 8.661 0 00-12.29 0',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M2 12a10 10 0 1020 0 10 10 0 00-20 0z',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
